import { useEffect, useState } from "react";
import { components } from "react-select";
import { default as ReactSelect } from "react-select";
import { Box, FormControl, Flex, Input } from "native-base";
import CommonBadge from "../badge";
import InputErrorMessage from "../inputErrorMessage";
import "./style.css";

const MultiSelectDropdown = ({
  label = "",
  name = "multidrop",
  selectedValues = "",
  defaultValue = "",
  setSelectedValues = () => {},
  text = "Select",
  dropItems = [],
  width = "auto",
  isDisabled = false,
  isInvalid = false,
  errorMessage = "Select option",
  handleSelectedValues = () => {},
  important = false,
  forceRemount = false,
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    setSelectedOptions(selectedValues);
  }, [selectedValues]);

  const Option = (props) => {
    const isSelected = props.isSelected;

    return (
      <div>
        <components.Option {...props}>
          <div className="custom-option">
            <span
              className={`checkmark ${isSelected ? "selected" : ""}`}
            ></span>
            <label className="option-label">{props.label}</label>
          </div>
        </components.Option>
      </div>
    );
  };

  const CustomMultiValueContainer = (props) => {
    return null;
  };

  const customStyles = {
    dropdownIndicator: (provided) => ({
      ...provided,
      "& svg": {
        fill: "rgb(142, 139, 139)",
        width: "25px",
        height: "16px",
      },
    }),
    clearIndicator: (provided) => ({
      ...provided,
      "& svg": {
        fill: "rgb(142, 139, 139)",
        width: "15px",
        height: "16px",
      },
    }),
  };

  const handleMultiSelectChange = (selectedValues) => {
    setSelectedOptions(selectedValues);
    setSelectedValues(selectedValues, name);
  };

  const CustomMultiValueRemove = () => null;

  // const handleSelectedValues = (ind) => {
  //   setSelectedOptions(selectedValues?.filter((item) => item.id !== ind));
  //   setSelectedValues(
  //     selectedValues?.filter((item) => item.id !== ind),
  //     name
  //   );
  // };

  return (
    <Box width={width}>
      <FormControl isInvalid={isInvalid} isDisabled={isDisabled} w={width}>
        {label && (
          <FormControl.Label>
            {label} {important && <span> *</span>}
          </FormControl.Label>
        )}
        <ReactSelect
          isDisabled={isDisabled}
          isInvalid={isInvalid}
          options={dropItems}
          isMulti
          closeMenuOnSelect={false}
          blurInputOnSelect={false}
          hideSelectedOptions={false}
          components={{
            Option,
            MultiValueRemove: CustomMultiValueRemove,
            MultiValueContainer: CustomMultiValueContainer,
          }}
          onChange={handleMultiSelectChange}
          allowSelectAll={true}
          defaultValue={defaultValue}
          value={selectedOptions}
          className={isInvalid ? "invalid-dropdown" : "multiselect-dropdown"}
          placeholder={`Select ${text}`}
          styles={customStyles}
          isSearchable={false}
        />
        {/* {selectedOptions.length > 0 && (
          <Flex direction="row" wrap="wrap" mt={3} space={2}>
            {selectedOptions.map((item, ind) => (
              <Box key={ind} mb={1} mr={2}>
                <CommonBadge
                  text={item.label}
                  handleSelectedValues={handleSelectedValues}
                  selectedIndex={item.id}
                />
              </Box>
            ))}
          </Flex>
        )} */}
        {isInvalid && <InputErrorMessage errorMessage={errorMessage} />}
      </FormControl>
    </Box>
  );
};

export default MultiSelectDropdown;
